<template>
  <div class="container">
    <h2>News and Events for Approval</h2>
    <v-layout row v-for="(event, i) in events" :key="event.id">
      <v-flex xs12 sm12>
        <v-card flat>
          <div class="pa-2">{{i+1}}. {{event.title}} : {{event.content}}</div>
          <v-layout row>
            <v-checkbox
              class="ml-3"
              :label="label+' : '+event.approved"
              v-model="event.approved"
              @change="changeStatus(event.id,event.approved)"
            ></v-checkbox>
            <v-btn flat @click="deleteContent(event.id)">
              <v-icon color="red darken-3">delete</v-icon>
              <span>DELETE</span>
            </v-btn>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { db, auth, functions } from "@/fb";

export default {
  data() {
    return {
      admin: false,
      row: true,
      events: [],
      approved: false,
      label: "Approved"
    };
  },
  methods: {
    deleteContent(docid) {
      //DELETE FROM DATABASE
      db.collection("events")
        .doc(docid)
        .delete();
      //REFRESH ARRAY
      this.events = [];
      db.collection("events").onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          this.events.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        });
      });
    },
    changeStatus(row, status) {
      db.collection("events")
        .doc(row)
        .update({
          approved: status
        })
        .then(() => {
          this.dialog = false;
          this.dialog2 = false;
          this.dial = false;
        })
        .catch(error => {
          console.log("Error updating" + error);
        });
    }
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    db.collection("events").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          if ((change.doc.data().approved = true)) {
            this.approved = "UnPublish";
            //this.row = true;
          } else {
            this.approved = "Publish";
            this.row = false;
          }
          this.events.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  }
};
</script>